<template>
  <v-app class="pa-6">
    <PWAPrompt />
    <Header />
    <Sidebar />
    <v-main class="content">
      <v-alert v-if="!gps" color="orange" dense prominent type="info"
        >Para ejecutar este sistema es necesario encender la geo localización de
        tu dispositivo.</v-alert
      >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header/Header";
import Sidebar from "@/components/Sidebar/Sidebar";
import PWAPrompt from "../PWAPrompt.vue";

import "./Layout.scss";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Layout",
  components: {
    PWAPrompt,
    Header,
    Sidebar,
  },
  data() {
    return {
      gps: true,
    };
  },
  watch: {
    "$store.state.gps": function () {
      this.gps = this.$store.state.gps;
    },
  },
};
</script>

<style src="./Layout.scss" lang="scss" />
